import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./interview_video.scss";
import axios from "axios";
const Interview_video = () => {
  const [interview, setInterview] = useState([]);
  const handleinterview = async () => {
    try {
      const response = await axios.get(
        "https://campaign.sambhajipatilnilangekar.com/wp-json/wp/v2/posts",
        {
          params: {
            per_page: 100,
            categories: 5,
          },
        }
      );
      setInterview(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    handleinterview();
  }, []);
  return (
    <div className="interview-video-parent parent">
      <h2>Interview Video Gallery</h2>
      <Swiper
        slidesPerView={4}
        spaceBetween={30}
        navigation={true}
        modules={[Navigation, Pagination]}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          1200: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 15,
          },

          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },

          576: {
            slidesPerView: 1,
            spaceBetween: 5,
          },
          300: {
            slidesPerView: 1,
            spaceBetween: 5,
          },
        }}
        className="mySwiper"
      >
        {interview.length > 0 ? (
          interview.map((video) => (
            <SwiperSlide key={video.id}>
              <div className="video-box">
                <div
                  className="first-box"
                  dangerouslySetInnerHTML={{ __html: video.content.rendered }}
                ></div>
              </div>
            </SwiperSlide>
          ))
        ) : (
          <div className="no-video">No videos available</div>
        )}
      </Swiper>
    </div>
  );
};

export default Interview_video;
